import { ApiError } from '../errors/api-error.js';

export class TenantComplianceApi {
    constructor(client) {
        this.client = client;
        this.basePath = '/tenant-compliance';
    }
    async frameworks() {
        try { return (await this.client.get(`${this.basePath}/frameworks`)).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async get() {
        try { return (await this.client.get(this.basePath)).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async toggle(code, enabled, customizations) {
        try { return (await this.client.post(`${this.basePath}/toggle`, { code, enabled, customizations })).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async listCatalogs() {
        try { return (await this.client.get(`${this.basePath}/catalogs`)).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async getCatalogScopeOptions() {
        try { return (await this.client.get(`${this.basePath}/catalogs/scope-options`)).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async getCatalogCategoryOptions() {
        try { return (await this.client.get(`${this.basePath}/catalogs/category-options`)).data; }
        catch (e) { throw ApiError.fromResponse(e); }
    }
    async listCatalogControls(tag, params = {}) {
        try {
            return (await this.client.get(
                `${this.basePath}/catalogs/${encodeURIComponent(tag)}/controls`,
                { params }
            )).data;
        } catch (e) { throw ApiError.fromResponse(e); }
    }
    async updateCatalog(tag, payload = {}) {
        try {
            return (await this.client.put(
                `${this.basePath}/catalogs/${encodeURIComponent(tag)}`,
                payload
            )).data;
        } catch (e) { throw ApiError.fromResponse(e); }
    }
}
